import React from 'react';
import {
  Menu,
  MenuList,
  MenuButton,
  IconButton,
  useDisclosure,
} from '@chakra-ui/react';
import { HiOutlineDotsVertical } from 'react-icons/hi';
import {
  MdOutlineModeEditOutline,
  MdDeleteOutline,
  MdOutlinePhotoLibrary,
} from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RiShareBoxLine } from 'react-icons/ri';
import { useMutation, useQueryClient } from 'react-query';

import { ServiceType } from '../types';
import { setEditingServiceId } from '../redux/slices/ServiceEditorSlice';
import { useAppDispatch } from '../redux/store';
import { deleteService } from '../api/services';
import { MyMenuItem, MyModal } from './MyCustomComponents';
import styles from './styles/service.module.scss';

const recurrenceMapper = (recurrence: string): string => {
  switch (recurrence) {
    case 'weekly':
      return 'wk';
    case 'monthly':
      return 'mo';
    case 'yearly':
      return 'yr';
    default:
      return 'mo';
  }
};

export const Service: React.FC<ServiceType> = ({
  id,
  imgUrl,
  serviceName,
  serviceUrl,
  category,
  price,
  recurrence,
}) => {
  // i18n
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { isOpen, onOpen, onClose } = useDisclosure();

  const dispatch = useAppDispatch();

  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(deleteService, {
    onSuccess: (data) => {
      console.log('successfully deleted');
      // console.log('data:', data);
      queryClient.setQueriesData('services', data);
      onClose();
    },
  });

  const handleClickEdit = () => {
    dispatch(setEditingServiceId(id));
    navigate('/edit');
  };

  return (
    <>
      <div className={styles.container}>
        {/* {`${imgUrl} | ${serviceName} | ${category} | ${cost}`} */}
        {imgUrl ? (
          <div className={styles.logo}>
            <img src={imgUrl} alt={serviceName} />
          </div>
        ) : (
          <MdOutlinePhotoLibrary
            style={{
              width: '43px',
              height: '43px',
              border: 'solid 1px #eee',
              padding: '6px',
            }}
          />
        )}

        <div className={styles.txt}>
          <div className={styles.service}>{serviceName}</div>
          <div className={styles.category}>{category}</div>
        </div>

        <div className={styles.cost}>
          ${price}
          <span>/{t(recurrenceMapper(recurrence!))}</span>
        </div>

        <Menu>
          <MenuButton
            className={styles.dotmenubtn}
            as={IconButton}
            aria-label="Options"
            icon={<HiOutlineDotsVertical className={styles.dotmenuicon} />}
            variant="none"
          />
          <MenuList>
            <MyMenuItem
              icon={<RiShareBoxLine className={styles.serviceMenuItemIcon} />}
              onClick={() => {
                window.open(serviceUrl, '_blank');
              }}
            >
              {t('go-to-website')}
            </MyMenuItem>
            <MyMenuItem
              icon={
                <MdOutlineModeEditOutline
                  className={styles.serviceMenuItemIcon}
                />
              }
              onClick={handleClickEdit}
            >
              {t('edit')}
            </MyMenuItem>
            <MyMenuItem
              icon={<MdDeleteOutline className={styles.serviceMenuItemIcon} />}
              onClick={onOpen}
            >
              {t('delete')}
            </MyMenuItem>
          </MenuList>
        </Menu>
      </div>

      <MyModal
        isOpen={isOpen}
        onClose={onClose}
        headerText={t('delete-modal-header')}
        bodyText={t('delete-modal-body')}
        submitBtnText={t('delete')}
        cancelBtnText={t('cancel')}
        onSubmitBtnClick={(e) => {
          e.preventDefault();
          mutate(id!);
        }}
        isSubmitBtnLoading={isLoading}
      />
    </>
  );
};
